import Vue from 'vue';
import { global } from './global.js';
import moment from 'moment-timezone';
import store from './store/store';
const freelanceSubdomain = 'freelance';
export default {
    freelanceSubdomain() {
        return freelanceSubdomain;
    },
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    disabledFrelenceUser() {
        if (store.getters.getSubdomain == freelanceSubdomain && store.getters.userRoleSlug == 'employee') {
            return false;
        }
        return true;
    },
    checkAccess(actionName) {
        var logInUserType = this.getCookie('csLogin');
        var powerSteward = this.getCookie('powerSteward');
        // var powerSteward=true;

        // add access from general user.
        // 'unDeclinedCall',
        var defaultUserAccess = [
            'jobEvent',
            'jobData',
            'schedule',
            'calender',
            // 'report',
            'support',
            'notify',
            'notifyMyJob',
            'notifyMyJobFilter',
            'switchClient',
            'scheduleActions',
            'publishJob',
            'editJob',
            'addNote',
            'addFile',
            'addCall',
            'callTimer',
            'employeeCSV',
            'jobCallCsv',
            'cloneCall',
            'editCall',
            'deleteCall',
            'splitCall',
            'clearAssign',
            'batchNotify',
            'phoneSheetActions',
            'callAssign',
            'addDocuments',
            'addNotes',
            'AddProfileNote',
            'myProfileFileDownload',
            'AddProfileDoc',
            'wishlistAction',
            'editEmployee',
            'resume',
            'callList',
            'drive'
        ];

        // remove access from power-user.
        var powerUserAccess = [
            'config',
            'deleteEmployee',
            'deleteEmployer',
        ];


        // remove access from power-user-minus.
        var powerUserMinusAccess = [
            'config',
            'deleteEmployee',
            'deleteEmployer',
            'editSkill',
            'archiveSkill',
            'addSkill',
            'ImportCSV',
        ];

        // remove access from auditor.
        var auditorUserAccess = [
            'config',
            'jobdelete',
            'deleteEmployee',
            'deleteEmployer',
            'addJob',
            'editJob',
            'publishJob',
            'silentDelete',
            'addNote',
            'addFile',
            'addCall',
            'callTimer',
            'employeeCSV',
            'jobCallCsv',
            'cloneCall',
            'editCall',
            'deleteCall',
            'splitCall',
            'clearAssign',
            'batchNotify',
            'phoneSheetActions',
            'addEmployee',
            'editEmployee',
            'callAssign',
            // 'scheduleActions',
            'unDeclinedCall',
            'addEmployer',
            'editEmployer',
            'addVenue',
            'editVenue',
            'deleteVenue',
            'editSkill',
            'archiveSkill',
            'ImportCSV',
            'addSkill',
            'addDocuments',
            'addNotes',
            'employeeSearch',
            'editUserProfile',
            'wishlistAction',
            'jobClone',
        ];

        var stewardSpecialAccess = [
            // 'config',
            // 'deleteEmployee',
            // 'deleteEmployer',
            'addJob',
            'jobdelete',
            'editJob',
            'jobData',
            'jobClone',
            'publishJob',
            'silentDelete',
            'jobNotes',
            'addNote',
            'addFile',
            'addCall',
            'callTimer',
            'employeeCSV',
            'jobCallCsv',
            'cloneCall',
            'editCall',
            'deleteCall',
            'splitCall',
            'clearAssign',
            'batchNotify',
            'phoneSheetActions',
            'addEmployee',
            'editEmployee',
            'callAssign',
            // 'report'
            // 'scheduleActions',
            // 'unDeclinedCall',
            // 'addEmployer',
            // 'editEmployer',
            // 'addVenue',
            // 'editVenue',
            // 'deleteVenue',
            // 'editSkill',
            // 'archiveSkill',
            // 'ImportCSV',
            // 'addSkill',
            // 'addDocuments',
            // 'addNotes',
            // 'employeeSearch',
            // 'editUserProfile',
            // 'wishlistAction'
        ];
        // console.log('powerSteward 1', powerSteward);
        if (logInUserType != "super-admin" && logInUserType != "client-admin" && logInUserType != "power-user" && logInUserType != "power-user-minus" && logInUserType != 'auditor') {
            if (defaultUserAccess.indexOf(actionName) != -1) {
                // console.log('powerSteward 2', powerSteward, actionName);
                return true;
            } else if (powerSteward == 1 && stewardSpecialAccess.indexOf(actionName) != -1) {
                // console.log('powerSteward 3', powerSteward, actionName);
                return true;
            }
            return false;
        } else if (logInUserType == "super-admin" || logInUserType == "client-admin" || logInUserType == "power-user" || logInUserType == "power-user-minus" || logInUserType == 'auditor') {
            if (logInUserType == "power-user") {
                if (powerUserAccess.indexOf(actionName) != -1) {
                    return false;
                } else {
                    return true;
                }
            } else if (logInUserType == "power-user-minus") {
                if (powerUserMinusAccess.indexOf(actionName) != -1) {
                    return false;
                } else {
                    return true;
                }
            } else if (logInUserType == 'auditor') {
                if (auditorUserAccess.indexOf(actionName) != -1) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }

        } else {
            //console.log("other user",actionName, defaultUserAccess.indexOf(actionName));
            return false;
        }

    },
    convertTo24Hours(time) {
        var hours = parseInt(time.substr(0, 2));
        if ((time.indexOf('am') != -1 || time.indexOf('AM') != -1) && hours == 12) {
            time = time.replace('12', '0');
        }
        if ((time.indexOf('pm') != -1 || time.indexOf('PM') != -1) && hours < 12) {
            time = time.replace(hours, (hours + 12));
        }
        var new_time = time.replace(/( am| pm| AM| PM)/, ':00');
        return new_time;
    },
    globalDate(date, defaultDateFormat = 'DD MMM YYYY') {
        var format = defaultDateFormat && defaultDateFormat !== '' ? defaultDateFormat : 'DD MMM YYYY';
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.utc(date).tz(timeZone).format(format);
        } else {
            return moment.utc(date).format(format);
        }
    },
    globalTime(date, defaultTimeFormat = 'hh:mm a') {
        var format = defaultTimeFormat && defaultTimeFormat !== '' ? defaultTimeFormat : 'hh:mm a';
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.utc(date).tz(timeZone).format(format);
        } else {
            return moment.utc(date).format(format);
        }
    },

    /**
     * Format a date stored as local time (datetime columns) — no UTC conversion.
     * Use for: calls.start/end, bookings.start/end, jobs.start/end, action_logs.start/end
     */
    localTime(date, defaultTimeFormat = 'hh:mm a') {
        var format = defaultTimeFormat && defaultTimeFormat !== '' ? defaultTimeFormat : 'hh:mm a';
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.tz(date, timeZone).format(format);
        }
        return moment(date).format(format);
    },
    localDate(date, defaultDateFormat = 'DD MMM YYYY') {
        var format = defaultDateFormat && defaultDateFormat !== '' ? defaultDateFormat : 'DD MMM YYYY';
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.tz(date, timeZone).format(format);
        }
        return moment(date).format(format);
    },
    localDateFull(date) {
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.tz(date, timeZone).format(' dddd Do, MMMM YYYY');
        }
        return moment(date).format(' dddd Do, MMMM YYYY');
    },
    localDateTime(date, defaultDateFormat = 'DD MMM YYYY', defaultTimeFormat = 'hh:mm a') {
        let dateFormat = defaultDateFormat && defaultDateFormat !== '' ? defaultDateFormat : 'DD MMM YYYY';
        let timeFormat = defaultTimeFormat && defaultTimeFormat !== '' ? defaultTimeFormat : 'hh:mm a';
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.tz(date, timeZone).format(`${dateFormat} ${timeFormat}`);
        }
        return moment(date).format(`${dateFormat} ${timeFormat}`);
    },

    globalDateTime(date, defaultDateFormat = 'DD MMM YYYY', defaultTimeFormat = 'hh:mm a') {
        // console.log("Date:", date);
        // console.log("Default Date Format:", defaultDateFormat);
        // console.log("Default Time Format:", defaultTimeFormat);
        // console.log("Resolved Date Format:", dateFormat);
        // console.log("Resolved Time Format:", timeFormat);
        // console.log("Final Format:", format);
        let dateFormat = defaultDateFormat && defaultDateFormat != '' ? defaultDateFormat : 'DD MMM YYYY';
        let timeFormat = defaultTimeFormat && defaultTimeFormat != '' ? defaultTimeFormat : 'hh:mm a';
        let format = `${dateFormat} ${timeFormat}`;
        return this.getUtcDateTimeToUserFormat(date, format);
        // return this.getDateTimeInUserFormat(date,format);
    },

    globalDateTime2(date, defaultDateFormat = 'DD MMM YYYY', defaultTimeFormat = 'hh:mm a') {
        let dateFormat = defaultDateFormat && defaultDateFormat != '' ? defaultDateFormat : 'DD MMM YYYY';
        let timeFormat = defaultTimeFormat && defaultTimeFormat != '' ? defaultTimeFormat : 'hh:mm a';
        let format = `${dateFormat} ${timeFormat}`;
        return this.utcTimeToUserTime2(date, format);
    },

    globalDate2(date, defaultDateFormat = 'DD MMM YYYY', defaultTimeFormat = 'hh:mm a') {
      let dateFormat = defaultDateFormat && defaultDateFormat != '' ? defaultDateFormat : 'DD MMM YYYY';
      return this.utcTimeToUserTime2(date, dateFormat);
  },

    getUserDateTime(date, defaultDateFormat = 'DD MMM YYYY', defaultTimeFormat = 'hh:mm a') {
        // console.log(defaultDateFormat);
        // console.log(defaultTimeFormat);
        let format = defaultDateFormat + ' ' + defaultTimeFormat
        return this.getDateTimeInUserFormat(date, format);
    },

    getUtcDateToUserFormat(date, defaultDateFormat = 'DD MMM YYYY') {
        var timeZone = this.getCookie('time_zone');

        if (timeZone != '') {
            // console.log(moment.utc(date).tz(timeZone).format(defaultDateFormat));
            return moment.utc(date).tz(timeZone).format(defaultDateFormat);
        } else {
            // console.log(moment.utc(date).format(defaultDateFormat));
            return moment.utc(date).format(defaultDateFormat);
        }
    },

    getUtcDateTimeToUserFormat(date, format='DD MMM YYYY hh:mm a') {
        if (!date) {
            return null;
        }
        try {
            var timeZone = this.getCookie('time_zone');
            if (timeZone && timeZone !== '') {
                return moment.utc(date).tz(timeZone).format(format);
            } else {
                return moment.utc(date).format(format);
            }
        } catch (error) {
            return null;
        }
    },

    getDateTimeInUserFormat(date, format) {
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.tz(date, timeZone).format(format);
        }
        return moment(date).format(format);
    },



    //timeString = "18:00:00"
    convertTo12Hours(timeString) {
        var H = +timeString.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? " AM" : " PM";
        timeString = h + timeString.substr(2, 3) + ampm;
        return timeString;
    },

    /**
      format = 12 or 24
    **/
    compareTime(start_time, end_time, format) {
        if (format == 12) {
            var start_converted = this.convertTo24Hours(start_time);
            var end_converted = this.convertTo24Hours(end_time);
        } else {
            var start_converted = start_time;
            var end_converted = end_time;
        }
        var start = start_converted.split(":");
        var end = end_converted.split(":");
        if (start[0] > end[0])
            return 1; //"Start time should be greater then end time";
        else if (start[0] == end[0]) {
            if (start[1] > end[1])
                return 1; //"Start time should be greater then end time";
            else
                return 0;
        } else
            return 0;
    },

    /**return Wed 14, Feb 2018 **/
    extractDateOnly(fullDate) {
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.utc(fullDate).tz(timeZone).format(' dddd Do, MMMM YYYY');
        } else {
            return moment.utc(fullDate).format(' dddd Do, MMMM YYYY');
        }
    },

    /**return 18:38:06 **/
    extractTimeOnly(fullTime) {
        var timeZone = this.getCookie('time_zone');
        if (timeZone && timeZone !== '') {
            return moment.utc(fullTime).tz(timeZone).format('HH:mm:ss');
        } else {
            return moment.utc(fullTime).format('HH:mm:ss');
        }
    },
    /**
     *calculate the hour difference between two dates
     send date=new Date() for present date

    **/
    hourDifference(date1, date2) {

        var hours = Math.round(Math.abs(date1 - date2) / 36e5);
        return hours;

    },
    /*
    Check if time is between two given times.
    */
    checkTimeIsbetween(startTime, endTime, time) {
        var dt = moment(time);

        //var startTime = '12:30:20';
        //var endTime = '23:10:10';

        var s = startTime.split(':');
        var dt1 = new Date(dt.year(), dt.month(), dt.date(), parseInt(s[0]), parseInt(s[1]), parseInt(s[2]));

        var e = endTime.split(':');
        var dt2 = new Date(dt.year(), dt.month(), dt.date(), parseInt(e[0]), parseInt(e[1]), parseInt(e[2]));

        if (dt >= dt1 && dt <= dt2) {
            return true;
        } else {
            return false;
        }
        //(dt >= dt1 && dt <= dt2)? 'Current time is between startTime and endTime' : 'Current time is NOT between startTime and endTime';
    },
    dateCheck(from, to, callStart, callEnd) {
        // console.log("Check 123:");
        // console.log(moment(from).format('dddd') + ' ' + from, moment(to).format('dddd') + ' ' + to, moment(callStart).format('dddd') + ' ' + callStart, moment(callEnd).format('dddd') + ' ' + callEnd);
        // var fDate, lDate, cDate;
        // fDate = Date.parse(from);
        // lDate = Date.parse(to);
        // cDate = Date.parse(check);
        // fDate = moment(from, 'YYYY-MM-DD HH:mm:ss').toDate(); // leave start date ex. 2021-08-19 08:00:00
        // lDate = moment(to, 'YYYY-MM-DD HH:mm:ss').toDate(); // leave end date ex. 2021-08-19 17:00:00
        // cDate = moment(check, 'YYYY-MM-DD HH:mm:ss').toDate(); // call start time or call end time ex. 2021-08-19 08:00:00 or 2021-08-19 17:59:00

        /** check if call start date and time or call end date and time is between leave start and end */
        if (moment(callStart).isBetween(from, to) || moment(callEnd).isBetween(from, to) || moment(callStart).isSame(from)) {
            // console.log("check time1",callStart, from, to);
            return true;
        }

        if (moment(from).isBetween(callStart, callEnd) || moment(to).isBetween(callStart, callEnd) || moment(from).isSame(callEnd)) {
            // console.log("check time2:", from, callStart, callEnd);
            return true;
        }
        // if ((cDate <= lDate || cDate >= fDate)) {
        //     return true;
        // }
        return false;
    },
    getHoursBetweenDate(date1, date2) {

    },
    utcTimeToUserTime(date) {
        var defaultFormat = 'YYYY/MM/DD @ HH:mm';
        var timeZone = this.getCookie('time_zone');
        // console.log("timeZone:",timeZone);
        if (timeZone != '') {
            return moment.utc(date).tz(timeZone).format(defaultFormat);
        } else {
            return moment.utc(date).format(defaultFormat);
        }
    },
    utcTimeToUserTime2(date,format='DD MMM YYYY @ HH:mm') {
        var timeZone = this.getCookie('time_zone');
        // console.log("timeZone:",timeZone);
        if (timeZone != '') {
            return moment.utc(date).tz(timeZone).format(format);
        } else {
            return moment.utc(date).format(format);
        }
    },
    utcTimeToUserDateTime(date, dateFormat, timeFormat) {
        var defaultFormat = 'YYYY/MM/DD @ HH:mm';
        var timeZone = this.getCookie('time_zone');
        if (timeZone != '') {
            return moment.utc(date).tz(timeZone).format(dateFormat + ' ' + timeFormat);
        } else {
            return moment.utc(date).format(defaultFormat);
        }
    },
    timeFromUtc(date) {
        var defaultFormat = this.getCookie('time_format');
        if (!defaultFormat && defaultFormat == '') {
            defaultFormat = 'hh:mm a';
        }

        var timeZone = this.getCookie('time_zone');
        if (timeZone != '') {
            return moment.utc(date).tz(timeZone).format(defaultFormat);
        } else {
            return moment.utc(date).format(defaultFormat);
        }
    },
    dateFromUtc(date) {
        var defaultFormat = this.getCookie('date_format');
        if (!defaultFormat && defaultFormat == '') {
            defaultFormat = 'DD MMM YYYY';
        }

        var timeZone = this.getCookie('time_zone');
        if (timeZone != '') {
            return moment.utc(date).tz(timeZone).format(defaultFormat);
        } else {
            return moment.utc(date).format(defaultFormat);
        }
    },
    withCustomFormat(date, format) {
        return moment.utc(date).format(format);
    },

    withCustomFormatForCallsList(date, format) {
        var timeZone = this.getCookie('time_zone');
        if (timeZone != '') {
            return moment.utc(date).tz(timeZone).format(format);
        } else {
            return moment.utc(date).format(format);
        }
    },

    getDateInputFormat() {
        var dateFormat = '';
        var defaultFormat = this.getCookie('date_format');
        if (!defaultFormat && defaultFormat == '')
            defaultFormat = 'mm/dd/YYYY';
        switch (defaultFormat) {
            case 'DD MMMM YYYY':
                dateFormat = 'dd MMMM yyyy';
                break;
            case 'DD MMM YYYY':
                dateFormat = 'dd MMM yyyy';
                break;
            case 'MM-DD-YY':
                dateFormat = 'MM-dd-yy';
                break;
            case 'YYYY-MM-DD':
                dateFormat = 'yyyy-MM-dd';
                break;
            case 'YYYY MMMM DD':
                dateFormat = 'yyyy MMMM dd';
                break;
            case 'YYYY MMM DD':
                dateFormat = 'yyyy MMM dd';
                break;

            case 'MMMM DD YYYY':
                dateFormat = 'MMMM dd yyyy';
                break;
            case 'MM/DD/YYYY':
                dateFormat = 'MM/dd/yyyy';
                break;
            default:
                dateFormat = 'MM/dd/yyyy';
        }
        return dateFormat;
    },
    getDatePlaceHolder() {
        var defaultFormat = this.getCookie('date_format');
        if (!defaultFormat && defaultFormat == '')
            defaultFormat = 'mm/dd/YYYY';
        return defaultFormat;
    },

    isCallstewardUK() {
        if (global[0].CLIENT_BASE == 'callsteward.uk/') {
            return true;
        }
        return false;
    },

    getMapUrl(address) {
        // console.log("https://www.google.com/maps/embed/v1/place?key=AIzaSyBngxxJ-H5reyDULmda4mWXJuyK1Hb6WTI&q="+address);
        let url = "https://www.google.com/maps/embed/v1/place?key=AIzaSyBngxxJ-H5reyDULmda4mWXJuyK1Hb6WTI&q=" + address;
        return url;
    },

    getSignInSheetUrl(route,data_source='') {
        // console.log(store.getters.gcsSignInSheetTemplate);
        let url = global[0].REPORT_URL + '#/' + route + btoa(store.getters.gcsSignInSheetTemplate);
        if (data_source != '') {
            url = url + '?data_source=' + btoa(data_source);
        }
        if (window.location.hostname == "localhost") {
            url = 'http://localhost:8081/#/' + route + btoa(store.getters.gcsSignInSheetTemplate) + '?data_source=' + btoa(data_source);
        }
        return url;
    },

    getEmployerSignInSheetUrl(route, gcsSignInSheetTemplate, data_source = '' ) {
        // console.log(gcsSignInSheetTemplate);
        // console.log(route);
        let url = global[0].REPORT_URL + '#/' + route + btoa(gcsSignInSheetTemplate) + '?data_source=' + btoa(data_source);;
        return url;
    },

    getEmployeeReportUrl(route, templateUrl,data_source='') {
        // templateUrl = "https://storage.googleapis.com/cs3bucket/public_files/831604408672.rdlx-json"

        let url = global[0].REPORT_URL + '#/' + route + btoa(templateUrl);
        if (data_source!='') {
            url = url + '?data_source=' + btoa(data_source);
        }
        if (window.location.hostname == "localhost") {
            // need to run the arjs app in a separate IDE(like vs-code)
            // copy and paste running localhost-node in place of (http://localhost:8081/#/) of arjs
            // url = window.location.href.split('')[0] + "#/" + route + btoa(templateUrl);
            url = 'http://localhost:8081/#/' + route + btoa(templateUrl)+'?data_source='+btoa(data_source);
        }
        // console.log(url);
        return url;
    }


}
